import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import loadingAnimaton from "@/components/loadingAnimaton/loadingAnimaton.vue";

var ToastButton =
/*#__PURE__*/
function (_Vue) {
  _inherits(ToastButton, _Vue);

  function ToastButton() {
    _classCallCheck(this, ToastButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(ToastButton).apply(this, arguments));
  }

  _createClass(ToastButton, [{
    key: "buyVip",
    value: function () {
      var _buyVip = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit("buyVip");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buyVip() {
        return _buyVip.apply(this, arguments);
      }

      return buyVip;
    }()
  }]);

  return ToastButton;
}(Vue);

tslib_1.__decorate([Prop({
  default: false
})], ToastButton.prototype, "freeText", void 0);

ToastButton = tslib_1.__decorate([Component({
  components: {
    loadingAnimaton: loadingAnimaton
  }
})], ToastButton);
export default ToastButton;